// src/modules/app-views/invoices/components/InvoicesGlobalSearch.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useListContext } from 'components/core/ListProvider';

import translateX from 'utils/translateX';
import './InvoicesGlobalSearch.less';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const DEBOUNCE_MS = 300;

// *******************************************************************************
// COMPONENT
// *******************************************************************************
const InvoicesGlobalSearch = ({ className }) => {
  const { setSearch } = useListContext() || {};

  const [searchValue, setSearchValue] = useState('');
  const debounceRef = useRef(null);

  // On mount: clear any _globalSearch persisted in URL params (?q=).
  // Field always starts empty — stale URL filter must not remain active.
  useEffect(() => {
    setSearch?.('_globalSearch', undefined);
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = useCallback(
    e => {
      const value = e?.target?.value ?? '';
      setSearchValue(value);

      if (debounceRef.current) clearTimeout(debounceRef.current);

      if (!value.trim()) {
        setSearch?.('_globalSearch', undefined);
      } else {
        debounceRef.current = setTimeout(() => {
          setSearch?.('_globalSearch', value.trim());
        }, DEBOUNCE_MS);
      }
    },
    [setSearch]
  );

  return (
    <Input
      className={`invoices-global-search ${className ?? ''}`}
      placeholder={translateX('search_invoice')}
      prefix={<SearchOutlined />}
      allowClear
      size="middle"
      value={searchValue}
      onChange={handleChange}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default InvoicesGlobalSearch;
